var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDevelopmentIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68.051,
    height: 54.841,
    viewBox: "0 0 68.051 54.841",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_8665237_code_development_icon",
    "data-name": "8665237_code_development_icon",
    d: "M42.933,3.3a3.3,3.3,0,0,0-6.48-.9L23.243,48.628a3.3,3.3,0,0,0-.128.908,3.26,3.26,0,0,0,3.306,3.3,3.3,3.3,0,0,0,3.174-2.4L42.8,4.209A3.306,3.306,0,0,0,42.933,3.3ZM18.164,14.769a3.3,3.3,0,0,0-5.637-2.335L.968,23.993a3.41,3.41,0,0,0,0,4.76L12.526,40.312a3.176,3.176,0,0,0,2.335.877A3.3,3.3,0,0,0,17.2,35.551L7.973,26.328,17.2,17.1A3,3,0,0,0,18.164,14.769ZM66.051,26.328a3.293,3.293,0,0,0-.968-2.336L53.525,12.433a3.719,3.719,0,0,0-2.335-.967A3.3,3.3,0,0,0,48.855,17.1l9.224,9.224-9.224,9.224a3.61,3.61,0,0,0-.968,2.333,3.3,3.3,0,0,0,5.637,2.335L65.083,28.662A2.985,2.985,0,0,0,66.051,26.328Z",
    transform: "translate(1 1)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevelopmentIcon);
export default __webpack_public_path__ + "static/media/development-icon.8c6d3211e4118d8d412543683633e33e.svg";
export { ForwardRef as ReactComponent };